<div class="container-fluid">
    <div class="row">
        <div class="col-md-3 col-lg-2">
            <div class="form-group">
                <label>Market<span>{{markets.filter(filterBy).length}}</span></label>
                <app-dropdown [list]="markets" name="market" placeholder="Select Market" (itemChange)="marketChange($event)"></app-dropdown>
            </div>
        </div>
        <div class="col-md-3 col-lg-2">
            <div class="form-group">
                <label>Sub - Market<span>{{subMarkets.filter(filterBy).length}}</span></label>
                <app-dropdown #subMarket [list]="subMarkets" name="subMarket" placeholder="Select Sub-Market" (itemChange)="subMarketChange($event)"></app-dropdown>
            </div>
        </div>
        <div class="col-md-3 col-lg-2">
            <div class="form-group">
                <label>Client<span>{{clients.filter(filterBy).length}}</span></label>
                <app-dropdown #client [list]="clients" name="client" placeholder="Select Client"></app-dropdown>
            </div>
        </div>
        <div class="col-md-3 col-lg-2">
            <button type="button" class="ct-btn tertiary-btn" (click)="onSearchClick()" [disabled]="isFilterEmpty">Apply</button>
        </div>

        <!-- <div class="col-md-3 col-lg-4">
            <div class="menu-user">
            <a href="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                 <button class="menu-button">
                    <i class="fa fa-bars" aria-hidden="true"></i>
                </button>
            </a>
              <ul class="dropdown-menu dropdown-menu-right">
                    <li (click)="onLaunchReport()">DMA Reports</li>
                    <li (click)="onLaunchMarginCalculator()">Margin CAl</li>
                    <li (click)="onLaunchSID()">SID</li>
                </ul>
        </div>  -->
        <!-- <div class="col-md-3 col-lg-4">

            <button type="button" class="ct-btn tertiary-btn float-right border report-button" (click)="onLaunchReport()">DMA Reports&nbsp;&nbsp;
                <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
            </button>
        </div>
        </div> -->
        <!-- <div class="col-md-3 col-lg-4">
            <div class="form-group">
                <button type="button" style="margin-top: -10px;" class="ct-btn tertiary-btn float-right border report-button" (click)="onLaunchReport()">DMA Reports&nbsp;&nbsp;
                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </button>
                <button type="button" style="margin-right: -123px; width: 170px;" class="ct-btn tertiary-btn float-right border report-button" (click)="onLaunchSID()">Sales Force Interface&nbsp;&nbsp;
                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </button>
            </div>
        </div> -->

        <div class="col-md-3 col-lg-4">
            <div class="form-group">
                <button type="button" style="margin-top: -18px; float: right;" class="ct-btn tertiary-btn float-right border report-button" (click)="onLaunchReport()">DMA Reports&nbsp;&nbsp;
                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </button>
                <!-- <button type="button" style="margin-top: 36px;margin-right: -123px; width: 170px;" class="ct-btn tertiary-btn float-right border report-button" (click)="onLaunchSID()">Sales Force Interface&nbsp;&nbsp;
                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </button> -->
                <button type="button" style="margin-top: 9px;margin-right: -123px; width: auto;float: right" class="ct-btn tertiary-btn float-right border report-button" (click)="onLaunchMarginCalculator()">Margin Calculator&nbsp;&nbsp;
                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </button>
                <button *ngIf="showMarginCost" type="button" style="width: auto;float: right;margin-top: 35px;margin-right: -144px;" class="ct-btn tertiary-btn float-right border report-button" (click)="onLaunchMarginCostUpload()">Finance File Upload&nbsp;&nbsp;
                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
</div>